// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

import PhoneNumberData from '../../types/PhoneNumberData';

import { format1 } from '../../constants';

/** Samoa */
const WS: PhoneNumberData = [685, 'WS', 7, format1];

export default WS;
